module.exports = __webpack_public_path__ + "static/img/tese-img6.3932517.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tese-img6.jpg
// module id = 936
// module chunks = 0